/**
 * Business logic per Cost Centers autocomplete
 * Pura - senza dipendenze da Vue
 */

import { isArray } from 'lodash-es';
import costCentersService from '../services/costCentersService';
import type { CostCenterAutocompleteResult } from '../models/costCenter';
import type { BaseAutocompleteOptions, ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export async function getCostCentersAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: BaseAutocompleteOptions = {},
): Promise<CostCenterAutocompleteResult[]> {
	const { searchString = '', id = null, notInIds = null } = options;

	const context: ODataContext = {
		select: 'id,name,isExternal',
		count: true,
		top: 20,
		orderBy: ['name'],
		filter: { and: [] },
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			'tolower(name)': { contains: searchString },
		});
	} else if (id) {
		context.filter!.and!.push({ id: { eq: id } });
	}

	if (notInIds && isArray(notInIds) && notInIds.length > 0) {
		context.filter!.and!.push({
			not: [{ id: { in: notInIds } }],
		});
	}

	const result = await costCentersService.getCostCenters(buildQuery(context));
	// OData select: id, name, isExternal - type safety garantita da Pick<>
	return result.value;
}
